<form class="popupForm" [formGroup]="componentForm">
  <div class="common" mat-dialog fxLayout="column" fxLayoutAlign="space-between" style="min-height: inherit;">
    <div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between end">
      Pick a user
      <button mat-icon-button mat-dialog-close id="close-upload" alt="close" title="close">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="when-fx-layout-broke flex-justify-start" style="display: flex !important; height: 500px;">

      <br>
      <div>
        <mat-form-field class="example-full-width" appearance="outline" color="accent" style="width: 100%">
          <mat-icon matPrefix>search</mat-icon>
          <input type="email" matInput placeholder="{{'search'|GetLabelPipe}}" formControlName="searchInput">
        </mat-form-field>
      </div>

      <div class="events-listing-container listing-full-size" style="margin-top: 20px !important;">

        <cdk-virtual-scroll-viewport itemSize="typicalItemHeight" minBufferPx="300" maxBufferPx="600"
                                     class="cdk-scroll">
          <div  class="file-row noselect" [class.center75]="true" [class.is-selected]="idx === activeIndex"
                *cdkVirtualFor="let listItem of usersFiltered; let idx = index"
                (click)="activeIndex = idx">
            <div matBadge="{{listItem.itemFullData['rank']}}" matBadgeColor="accent">
              <img alt="" title="{{listItem.name}}"
                   src="{{listItem.picture_ava}}" class="list-item-image"
                   style="{{ listItem.itemFullData.sex==='F' ? 'border-color: #FF1744' : 'border-color: #448AFF' }}"
              />
            </div>

            <div class="file-name noselect">
              {{listItem.name}}<br/>
              <div class="subrow subrow-trainer flex-row-center" *ngIf="listItem['itemFullData']['shipping_phone']">
                <mat-icon style="width: 16px;">phone</mat-icon>&nbsp;&nbsp;&nbsp;+{{listItem['itemFullData']['shipping_phone']}}
              </div>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>

      </div>
      <br>
    </mat-dialog-content>
    <div fxLayout="row" fxLayoutAlign="space-between end" fxLayoutGap="10px">
      <button mat-button class="cancel widerButton font16" (click)="onNoClick()">
        {{'cancel'|GetLabelPipe}}
      </button>
      <button type="submit" class="widerButton font16" mat-raised-button color="accent" [disabled]="activeIndex<0"
              (click)="userPicked()">
        {{'pick'|GetLabelPipe}}
      </button>
    </div>
  </div>
</form>
